module.exports = __webpack_public_path__ + "img/doc.37a56acc.svg";